<template>
    <div class="modal-material" v-loading="loading">
        <div class="material-con">
            <div class="left">
                <div class="con">
                    <div class="item-content">
                        <div class="view">

                            <div style="height: 100%">
                                <img class="item-view-img"
                                     :src="show_img"
                                     v-on:load="imageLoaded" v-on:error="imageFailed"  slot="reference" @click="handlePreview"
                                     v-if="material_info.material_type == 1"
                                />

                                <div class="relative" v-else-if="material_info.material_type == 2">
                                    <video ref="smallVideo" class="item-view-img" style="height: 100%"
                                           :src="material_info.material_url" loop autoplay controls preload="metadata"
                                           :allowfullscreen="true"
                                           disablePictureInPicture="true"
                                           disableRemotePlayback="true"
                                           @loadeddata="onSmallVideoLoaded"
                                    ></video>
                                    <div class="fullScreen"  @click="handlePreview"><i class="el-icon-full-screen"></i></div>
                                </div>
                            </div>

                            <div class="view-con">
                                <el-tooltip class="item" effect="dark" content="素材尺寸" placement="top">
                                    <span>{{ material_info.width }} * {{material_info.height}}</span>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="素材大小" placement="top">
                                    <span>{{ material_info.material_size }}{{material_info.material_size_unit}}</span>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="素材时长" placement="top" v-if="material_info.material_duration && material_info.material_duration != '-'">
                                    <span>{{ material_info.material_duration }}</span>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="素材格式" placement="top">
                                    <span>{{ material_info.material_format }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>

                    <div class="displayTag mt10">
                        <template v-if="material_info.label_list && Array.isArray(material_info.label_list)">
                            <!-- workOrder_v5 需求一：id=-1 为后端按素材分类标签四级归类出的伪标签（多条），level=0 为「未知」用 danger 色，title 带原文 -->
                            <el-tag size="mini" effect="plain" :type="item.id ==='-1'?(item.level===0?'danger':'warning'):'info'" :title="item.title || ''" style="margin-right: 5px;" v-for="(item, index) in material_info.label_list" :key="index">{{item.name}}</el-tag>
                        </template>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="con">
                    <div class="info_item">
                        <h5>素材信息</h5>
                        <div class="info_item_con mt10">
                            <div class="label">素材名称：</div>
                            <div class="value">{{ material_info.material_name }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">MD5：</div>
                            <div class="value">{{ material_info.material_md5 }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">上传人：</div>
                            <div class="value">{{ material_info.upload_name }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">上传时间：</div>
                            <div class="value">{{ material_info.upload_time }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">使用状态：</div>
                            <div class="value">{{ material_info.is_used_text }}</div>
                        </div>
                        <div class="info_item_con mt10" v-if="material_info.refusal_reason">
                            <div class="label">拒绝原因：</div>
                            <div class="value">{{ material_info.refusal_reason }}</div>
                        </div>
                    </div>

                    <div class="info_item mt20">
                        <h5>制作信息</h5>
                        <div class="info_item_con mt10">
                            <div class="label">制作人：</div>
                            <div class="value">{{ getTextConent }}</div>
                        </div>
<!--                        <div class="info_item_con mt10">-->
<!--                            <div class="label">编导：</div>-->
<!--                            <div class="value">{{ getTextConentDirector }}</div>-->
<!--                        </div>-->
                        <div class="info_item_con mt10">
                            <div class="label">内部来源：</div>
                            <div class="value">{{ producer_info.source }}</div>
                        </div>
                    </div>

                    <div class="info_item mt20">
                        <h5>工单信息</h5>
                        <div class="info_item_con mt10">
                            <div class="label">工单ID：</div>
                            <div class="value">{{ order_info.order_id }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">任务ID：</div>
                            <div class="value">{{ order_info.detail_id }}</div>
                        </div>
                    </div>

                    <div class="info_item mt20">
                        <h5>项目信息</h5>
                        <div class="info_item_con mt10">
                            <div class="label">项目：</div>
                            <div class="value">{{ project_info.project_name_show }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">产品类型：</div>
                            <div class="value">{{ project_info.app_type_text||'-' }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">包体类型：</div>
                            <div class="value">{{ project_info.package_type_text||'-' }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">游戏分类：</div>
                            <div class="value">{{ project_info.game_classify_text }}</div>
                        </div>
                         <div class="info_item_con mt10">
                            <div class="label">游戏类型：</div>
                            <div class="value">{{ project_info.project_tag11_text }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">游戏题材：</div>
                            <div class="value">{{ project_info.project_tag12_text }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">媒体：</div>
                            <div class="value">{{ project_info.plat_name }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">投放场景：</div>
                            <div class="value">{{ project_info.delivery_scene_text }}</div>
                        </div>
                        <div class="info_item_con mt10">
                            <div class="label">投放版位：</div>
                            <div class="value">{{ project_info.delivery_type_text }}</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="material-footer mt20">
            <div>
                <el-button  @click="handlePrev">上一个</el-button>
                <el-button  @click="handleNext">下一个</el-button>
            </div>
            <div>
                <el-button v-if="authDown" :loading="downloading" @click="handleOnlyDown">下载</el-button>
                <el-button type="danger" v-if="authReject" plain @click="handleReject">拒绝</el-button>
                <el-button type="primary" v-if="authPass" @click="handlePass">通过</el-button>


                <el-button type="primary" v-if="authReUpload" @click="handleReUpload">重新上传</el-button>
                <el-button type="danger" plain v-if="authDel" @click="handleDel">删除</el-button>
                <el-button type="danger" plain v-if="authStoreDel" @click="handleauthStoreDel">删除</el-button>
                <el-button type="primary" v-if="authEdit" @click="handleEdit">编辑</el-button>
            </div>
        </div>
        <div class="fixMask" v-if="show">
            <div class="order-image-viewer__mask"></div>
            <span class="order-image-viewer__btn el-icon-error order-image-viewer__close" @click="handleClose"></span>
            <div class="order-image-viewer__canvas">
                <img :src="show_img" class="el-image-viewer__img"
                     style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; max-height: 100%; max-width: 100%;"
                v-if="material_info.material_type == 1"
                >
                <video ref="fullscreenVideo" class="el-image-viewer__img" style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; max-height: 100%; max-width: 100%;"
                       :poster="encodeURI(material_info.img_material_url)"
                       :src="encodeURI(material_info.material_url)" loop controls preload="auto"
                       controlslist="nodownload noremoteplayback noplaybackrate"
                       disablePictureInPicture="true"
                       disableRemotePlayback="true"
                       v-else-if="material_info.material_type == 2"
                       @loadeddata="onFullscreenVideoLoaded"
                ></video>`
            </div>
        </div>
    </div>
</template>

<script>
// https://sf3-cdn-tos.toutiaostatic.com/obj/mp/welcome-video.mp4
// https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/618b413686b1d/原素材03.mp4
import API from "@/api/workOrder/store.js"
import APIMaterial from "@/api/workOrder/material.js"
import EllipsisTips from "@/views/workOrder/components/ellipsisTips.vue";
import noImg from '@/assets/img/mi-no-img.png';
import {rejectModal, resultOnceModal} from "@/views/workOrder/material/pages/modalMaterial";
import {rejectModal as taskRejectModel} from "@/views/workOrder/material/pages/taskInfo/modal";
import {downloadFile} from "@/views/workOrder/components/utils";
import matomoFun from "@/utils/matomo.js";
export default {
    name: "previewMaterialModal",
    components: {EllipsisTips},
    props:{
        cbs:{
            type:Object,
        },
        fromTitle:String,
        activeTabs:String,
        typeText:String,
        id:[Number, String],
        list:Array,
        fetch:String,
        authEdit: false, //是否可以被编辑
        authDown: false, //下载权限的链接
        downFetch: '', // 下载走的请求
        authReUpload: false, // 重新上传权限
        authDownHref: '', //下载权限的链接
        authPass: false,  //工单管理 - 通过
        authReject : false,  //工单管理 - 拒绝
        authDel: false,  // 工单管理-任务管理 删除
        authStoreDel: false, // 素材库 删除
    },
    data(){
        return {
            moreTags: false,
            loading:false,
            download_loading: false,
            material_info:{},
            order_info:{},
            producer_info:{},
            project_info:{},
            material_index:'',
            show: false,
            no_img: noImg,
            show_img: '',
            _id:'',
            _list:[],
            downloading: false,
            fullscreenVideoReady: false,
        }
    },
    watch: {
        'material_info':{
            handler(n) {
                this.show_img = n?.img_material_url ? encodeURI(n?.img_material_url) : ''
            },
            deep: true,
            immediate:true
        },
        'list':{
            handler(n) {
                this._list = n
            },
            deep: true,
            immediate:true
        },
        'id':{
            handler(n) {
                this._id = n
            },
            immediate:true
        }
    },
    computed:{
        tipText(){
            let tipText = '内容';
            let typeText = this.typeText||'';
            if(typeText.includes('产品')){
                tipText = '名称/ID/包名';
            }else if(typeText.includes('账户')||typeText.includes('计划')){
                tipText = '名称/ID';
            }
            return tipText;
        },
        getTextConent() {
            let producer_list = this.producer_info.producer_list
            let text = ''
            if(Array.isArray(producer_list) && producer_list.length !=0) {
                producer_list.forEach(item=>{
                    let ratio = item.ratio ? (item.ratio * 100).toFixed(2) : ''
                    if(ratio) {
                        text += `${item.name}(${ratio}%);`
                    }else{
                        text += `${item.name};`
                    }
                })
            }else{
                text = '-'
            }
            return text
        },
    },
    mounted() {
        this.material_index = this._list.findIndex(item=>item.id == this._id)
        let cur_params = {
            material_id: this._list[this.material_index]['id'],
            source: this._list[this.material_index]['source'] ? this._list[this.material_index]['source'] : ''
        }
        this.fetchInfo(cur_params)

        this.$nextTick(function() {
            // 按下键盘
            document.addEventListener('keydown', (e) => {
                // Esc按键是27
                if (e.keyCode == 27) {
                    // 关闭弹框时停止视频播放并恢复小视频声音
                    if (this.material_info.material_type == 2) {
                        this.stopAllVideos()
                        this.$nextTick(() => {
                            if (this.$refs.smallVideo) {
                                this.$refs.smallVideo.muted = false
                            }
                        })
                    }
                    this.show = false
                }
            });
        });

    },
    beforeDestroy() {
        // 组件销毁前停止所有视频播放
        this.stopAllVideos()
    },
    methods:{
        pushMatomo(name) {
            matomoFun.trackEvent(this.fromTitle || '素材库', '点击', name)
        },
        // 视频同步方法
        syncVideoTime(sourceVideo, targetVideo, targetMuted = false) {
            if (!sourceVideo || !targetVideo) return

            const doSync = () => {
                try {
                    targetVideo.currentTime = sourceVideo.currentTime
                    targetVideo.muted = targetMuted
                    if (!sourceVideo.paused) {
                        targetVideo.play()
                    } else {
                        targetVideo.pause()
                    }
                } catch (error) {
                    console.warn('视频同步失败:', error)
                }
            }

            // 检查目标视频是否已准备好
            if (targetVideo.readyState >= 2) { // HAVE_CURRENT_DATA
                doSync()
            } else {
                // 等待视频加载到可操作状态
                const handleLoadedData = () => {
                    doSync()
                    targetVideo.removeEventListener('loadeddata', handleLoadedData)
                }
                targetVideo.addEventListener('loadeddata', handleLoadedData)

                // 设置超时，避免无限等待
                setTimeout(() => {
                    targetVideo.removeEventListener('loadeddata', handleLoadedData)
                    // 即使没完全加载也尝试同步
                    doSync()
                }, 3000)
            }
        },
        // 停止所有视频播放
        stopAllVideos() {
            try {
                if (this.$refs.smallVideo) {
                    this.$refs.smallVideo.pause()
                }
                if (this.$refs.fullscreenVideo) {
                    this.$refs.fullscreenVideo.pause()
                }
            } catch (error) {
                console.warn('停止视频播放失败:', error)
            }
        },
        // 小视频加载完成回调
        onSmallVideoLoaded() {
            // 确保小视频默认有声音
            if (this.$refs.smallVideo) {
                this.$refs.smallVideo.muted = false
            }
        },
        // 全屏视频加载完成回调
        onFullscreenVideoLoaded() {
            this.fullscreenVideoReady = true
        },
        fetchInfo(params) {
          this.loading = true
          API[this.fetch](params).then(res=>{
            const {material_info, order_info, producer_info, project_info} = res.data
              this.$nextTick(()=>{
                  this.material_info = material_info
                  this.order_info = order_info
                  this.producer_info = producer_info
                  this.project_info = project_info
                  
                  // 确保新加载的小视频有声音
                  this.$nextTick(() => {
                      if (this.$refs.smallVideo && this.material_info.material_type == 2) {
                          this.$refs.smallVideo.muted = false
                      }
                  })
              })
          },err=>{
            this.$message.error(err.info)
          }).finally(()=>{
              this.loading = false
          })
        },
        // 预览
        handlePreview() {
            this.show = true

            // 如果是视频类型，同步播放进度并处理声音
            if (this.material_info.material_type == 2) {
                this.$nextTick(() => {
                    // 小视频静音，全屏视频有声音
                    if (this.$refs.smallVideo) {
                        this.$refs.smallVideo.muted = true
                    }
                    // 同步播放进度，全屏视频不静音
                    this.syncVideoTime(this.$refs.smallVideo, this.$refs.fullscreenVideo, false)
                })
            }

            this.pushMatomo('查看素材详情(上一个)')
        },
        handleClose() {
            // 如果是视频类型，停止所有视频播放
            if (this.material_info.material_type == 2) {
                this.stopAllVideos()
                // 恢复小视频的声音（取消静音）
                this.$nextTick(() => {
                    if (this.$refs.smallVideo) {
                        this.$refs.smallVideo.muted = false
                    }
                })
            }

            this.show = false
            this.pushMatomo('查看素材详情(下一个)')
        },
        // 上一个
        handlePrev() {
            --this.material_index
            if(this.material_index < 0) {
                this.material_index = 0
                return this.$message.warning('当前页素材已全部预览完')
            }
            let cur_params = {
                material_id: this._list[this.material_index]['id'],
                source: this._list[this.material_index]['source'] ? this._list[this.material_index]['source'] : ''
            }
            this.fetchInfo(cur_params)
        },
        // 下一个
        handleNext() {
            ++this.material_index
            let max_length = this._list.length - 1
            if(this.material_index > max_length) {
                this.material_index = max_length
                return this.$message.warning('当前页素材已全部预览完')
            }
            let cur_params = {
                material_id: this._list[this.material_index]['id'],
                source: this._list[this.material_index]['source'] ? this._list[this.material_index]['source'] : ''
            }
            this.fetchInfo(cur_params)
        },
        // 跳转到上一步 或 下一步
        handleJump() {
            let max_length = this._list.length - 1
            if(max_length == '-1') {
                this.cbs.onClose()
                return
            }
            if(this.material_index < 0 || this.material_index > max_length) {
                this.material_index = 0
            }
            let cur_params = {
                material_id: this._list[this.material_index]['id'],
                source: this._list[this.material_index]['source'] ? this._list[this.material_index]['source'] : ''
            }
            console.log('cur_params',cur_params, this._list)
            this.fetchInfo(cur_params)
        },
        // 单独下载
        handleOnlyDown() {
            this.pushMatomo('查看素材详情(下载)')
            this.downloading = true
            APIMaterial[this.downFetch]({
                material_id: this.downFetch == 'getOnlyDownLoad' ? this._list[this.material_index]['download_id'] : this._list[this.material_index]['id'],
                source: this._list[this.material_index]['source'] ? this._list[this.material_index]['source'] : ''
            }).then(res=>{let result = res.data
                downloadFile(result)
            },err=>{
                this.$message.error(err.info||'请求异常');
            }).finally(()=>{
                this.downloading = false
            })
        },
        // 通过
        handlePass() {
            // this.cbs.onPass(this._list[this.material_index]['id'])
            if(this.activeTabs === 'no_audit_list') {
                APIMaterial.postWorkOrderPass({material_id:this._list[this.material_index]['id']}).then(res=>{
                    this.$message.success(res.info)
                    this.cbs.onPass(this.material_index).then(()=>{
                        this.handleJump()
                    })
                },err=>{
                    this.$message.error(err.info)
                })
                return
            }
            const { vm } = resultOnceModal(
                {
                    props: {
                        hasLoading: true,
                        id:this._list[this.material_index]['id'],
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            vm.close()
                            this.cbs.onPass(this.material_index).then(()=>{
                                this.handleJump()
                            })
                        },
                    }
                }
            )
        },
        // 拒绝
        handleReject() {
            if(this._list[this.material_index]['is_used'] == '1') {
                return this.$message.error('素材已经使用，无法拒绝。')
            }

            // this.material_index = this._list.findIndex(item=>item.id == this._id)


            let group_ids = this._list[this.material_index]['id']
            const { vm } = rejectModal(
                {
                    props: {
                        hasLoading: true,
                        id:[group_ids],
                        type: 'only'
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            vm.close()
                            this.cbs.onReject(this.material_index).then(()=>{
                                this.handleJump()
                            })
                        },
                    }
                }
            )
        },
        // 编辑
        handleEdit() {
            // 可以被编辑时 跳转前 请关闭弹框
            this.pushMatomo('查看素材详情(编辑)')
            let materialInfo = Object.assign({},this.project_info,this.material_info,this.producer_info);
            materialInfo.director = materialInfo.director=='-'?'':materialInfo.director;
            this.cbs.onEdit(materialInfo);
            this.$emit('close');
        },
        // 删除
        handleDel() {
            let group_ids = this._list[this.material_index]['id']
            const {vm} = taskRejectModel(
                {
                    props:{
                        fetch: 'postWorkTaskBatchDelete',
                        postItems: {material_id:group_ids}
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            vm.close()
                            this.cbs.onDelete().then(()=>{
                                this.handleJump()
                            })
                            // this.getInfo()
                            // this.$emit('reloadColumn', this.rows.assign_id)
                        },
                    }
                }
            )
        },
        // 素材库删除
        handleauthStoreDel() {
            this.cbs.onDel().then(()=>{
                this.handleJump()
            })
        },
        // 重新上传
        handleReUpload() {
            this.cbs.onReload()
        },
        imageLoaded() {
        },
        imageFailed() {
            this.show_img = this.no_img
        },
        hideBatchModal(){
            this.$emit('close');
        },
        hideLoading(){
            this.batchLoading = false;
        },
        submitBatchModal(){
            this.batchLoading = true;
            this.cbs.onSubmit(this.batchCon.split(/\n/).map(item=>item.trim()).filter(item=>!!item), this.hideLoading);
        },
    },
}
</script>

<style scoped lang="scss">
.material-con{
    display: flex;
    // height: calc(100vh - 290px);
    height: 60vh;
    justify-content: space-between;
    .left {
        width: 60%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .con{
            height: 0;
            flex: 1;
            overflow: auto;
        }
        .view{
            border: 1px solid #DCDFE6;
            position: relative;
            // height: calc(100vh - 320px);
            height: 55vh;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 25px;
            .item-view-img{
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: center;
                cursor: pointer;
            }
            .view-con{
                font-size: 12px;
                position: absolute;
                width: 100%;
                background-color: #ecf5ffc4;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                padding: 4px;
                bottom: 0;
                span{
                    cursor: pointer;
                }
            }
            .relative{
                position: relative;
                height: 100%;
                .fullScreen{
                    position: absolute;
                    right: 12px;
                    bottom: 65px;
                    font-size: 22px;
                    color: #fff;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    &:hover{
                        transform: scale(1.1);
                    }
                }
            }
        }
        .displayTag{
            //display: flex;
            width: 100%;

            //.left_tag{
            //    flex: 1;
            //    min-width: 0;
            //    overflow: hidden;
            //    display: flex;
            //    padding-right: 6px;
            //    .el-tag{
            //        margin-right: 6px;
            //    }
            //}
            //.right_tag{
            //    width: 50px;
            //    flex:  0 0 50px;
            //    text-align: right;
            //}

        }
    }
    .right {
        width: 38%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .con{
            height: 0;
            flex: 1;
            overflow: auto;
            .info_item{
                .info_item_con{
                    display: flex;
                    align-items: flex-start;
                    width: 100%;
                    font-size: 12px;
                    padding-left: 20px;
                    .label{
                        flex: 0 1 70px;
                    }
                    .value{
                        flex: 1;
                        overflow-x: hidden;
                        word-wrap: break-word;
                    }
                }
            }
        }
    }
}
.material-footer{
    display: flex;
    justify-content: space-between;
}
.fixMask{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    .order-image-viewer__mask{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: .8;
        background: #000;
    }
    .order-image-viewer__btn{
        position: absolute;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        opacity: .8;
        cursor: pointer;
        box-sizing: border-box;
        user-select: none;
    }
    .order-image-viewer__close{
        top: 40px;
        right: 40px;
        width: 40px;
        height: 40px;
        font-size: 40px;
        color: #fff;
        background-color: #606266;
    }
    .order-image-viewer__canvas{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

</style>
